import type {
  DraggableAttributes,
  DraggableSyntheticListeners,
} from '@dnd-kit/core';
import { Box, IconButton, type SxProps, type Theme } from '@mui/material';
import { GripVerticalIcon } from 'lucide-react';

export type DragHandleProps = {
  attributes: DraggableAttributes;
  listeners: DraggableSyntheticListeners;
  isDragging: boolean;
  variant?: 'inline' | 'icon-button';
  rotateIcon?: boolean;
  sx?: SxProps<Theme>;
  className?: string;
};

const normalizeSx = (sx: SxProps<Theme> | undefined) =>
  Array.isArray(sx) ? sx : sx ? [sx] : [];

export const DragHandle = ({
  attributes,
  listeners,
  isDragging,
  variant = 'inline',
  rotateIcon = false,
  sx,
  className,
}: DragHandleProps) => {
  const cursor = isDragging ? 'grabbing' : 'grab';
  const iconTransform = rotateIcon ? 'rotate(90deg)' : undefined;

  if (variant === 'icon-button') {
    return (
      <IconButton
        size="small"
        className={className}
        sx={[{ cursor }, ...normalizeSx(sx)]}
        {...attributes}
        {...listeners}
      >
        <GripVerticalIcon style={{ transform: iconTransform }} size={18} />
      </IconButton>
    );
  }

  return (
    <Box
      className={className}
      sx={[
        {
          cursor,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        ...normalizeSx(sx),
      ]}
      {...attributes}
      {...listeners}
    >
      <GripVerticalIcon style={{ transform: iconTransform }} size={18} />
    </Box>
  );
};
